import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormSelectModelDto } from '../../pages/payment-link-list/models/paylinks.model';

@Component({
  selector: 'app-form-modal-select',
  templateUrl: './form-modal-select.component.html',
  styleUrls: ['./form-modal-select.component.scss'],
})
export class FormModalSelectComponent {
  @ViewChild('selectList') selectList?: ElementRef;
  @Input() isLoading: boolean = false;
  @Input() positionList: string | 'top' | 'bottom' = 'bottom';
  @Input() title = '';
  @Input() itemList: FormSelectModelDto[] = [];
  @Input() selectedItem: FormSelectModelDto | undefined;
  @Input() isDisableSelect = false;
  @Output() selectedItemChange: EventEmitter<FormSelectModelDto> =
    new EventEmitter<FormSelectModelDto>();
  @Output() loadMore: EventEmitter<void> = new EventEmitter<void>();

  isOpenSelect = false;

  constructor(private el: ElementRef) {}

  checkScrollPosition(event: any) {
    const tableBodyHeight = this.selectList?.nativeElement.clientHeight;
    const scrollTable = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;

    if (scrollTable + tableBodyHeight >= scrollHeight && !this.isLoading) {
      this.loadMore.emit();
    }
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpenSelect = false;
    }
  }

  toggleSelect() {
    if (!this.isDisableSelect) {
      this.isOpenSelect = true;
    }
  }

  setSelectedItem(item: FormSelectModelDto) {
    this.selectedItem = item;
    this.selectedItemChange.emit(item);
    this.isOpenSelect = false;
  }
}
